/* global BigInt */
import { assertSportsbookHistoryDetail } from '../contracts/sportsbookHistoryResponse.contract.js';
import { sportsbookHistoryRowMatchesQuery } from './sportsbookHistoryQueryParams.query.js';

const versionOf = (value) => {
  if (typeof value !== 'string' || !/^[1-9]\d{0,18}$/.test(value)) {
    throw new TypeError('history row_version must be a bounded positive integer');
  }
  return BigInt(value);
};

export const authoritativeSportsbookHistoryRow = (detail) => {
  assertSportsbookHistoryDetail(detail);
  versionOf(detail.row_version);
  if (detail.status !== 'CANCELLED' || detail.capabilities.can_cancel !== false) {
    throw new TypeError('confirmed cancellation detail is required');
  }
  const { selections, detail_generation: _generation, detail_hash: _hash, ...row } = detail;
  return { ...row, preview_selection: selections[0] ?? null };
};

export const patchSportsbookHistoryRows = (rows, confirmed, query) => rows.flatMap((row) => {
  if (row.history_id !== confirmed.history_id) return [row];
  const next = versionOf(confirmed.row_version) >= versionOf(row.row_version) ? confirmed : row;
  return sportsbookHistoryRowMatchesQuery(next, query) ? [next] : [];
});

export const patchSportsbookHistoryPageToken = (token, confirmed, query) => token === null
  ? null
  : { ...token, bufferedRows: patchSportsbookHistoryRows(token.bufferedRows, confirmed, query) };

export const patchSportsbookHistoryCursorState = (state, confirmed, query) => ({
  ...state,
  currentPageToken: patchSportsbookHistoryPageToken(state.currentPageToken, confirmed, query),
  visitedPageTokens: state.visitedPageTokens.map((token) => (
    patchSportsbookHistoryPageToken(token, confirmed, query)
  )),
});

// Fence before scheduling React state so a late list response cannot undo the confirmed row.
export const invalidateSportsbookHistoryRead = (requestRef) => {
  requestRef.current.controller?.abort();
  requestRef.current = { controller: null, generation: requestRef.current.generation + 1 };
};

